import React from "react";

// interface DataSourceProps {
//   sources: string[];
//   setSelectedDataSource: any;
//   selectedDataSource: any;
// }

const DataSourceList = ({
  sources,
  setSelectedDataSource,
  selectedDataSource,
}) => {
  return (
    <ul className="flex overflow-x-auto -mx-2 border-b hide-scrollbar">
      {sources.map((source) => (
        <li
          key={source}
          className="flex items-center"
          onClick={() => setSelectedDataSource(source)}
        >
          <div
            className={`${
              selectedDataSource === source &&
              "border-b-4 border-cyan-700 text-cyan-700"
            } transition duration-300 px-4 pb-2 cursor-pointer`}
          >
            <span className="text-purple-500">
              {/* Icon depending on type */}
            </span>
            <p className=" text-sm">{source}</p>
          </div>
        </li>
      ))}
    </ul>
  );
};

export default DataSourceList;
